import { render, staticRenderFns } from "./purchase-intentions-houses.vue?vue&type=template&id=143c7a82"
import script from "./purchase-intentions-houses.vue?vue&type=script&lang=ts"
export * from "./purchase-intentions-houses.vue?vue&type=script&lang=ts"
import style0 from "./purchase-intentions-houses.vue?vue&type=style&index=0&id=143c7a82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol})
